"use client";
import {
  ButtonComponent,
  DividerComponent,
  PaperComponent,
} from "@/components";
import React, { useEffect, useState } from "react";
import MatrixBorderProgressBar from "./progess";
import { ChevronRight } from "@mui/icons-material";
import { Typography, Grid, Stack } from "@mui/material";
import MultiSegmentProgressBar from "./multiprogressbar";
import { useGetCustomerQuery, useInitiatePaymentMutation } from "@/lib/redux";
import { CurrencyConverter, WEB_COLORS, WEB_EVENTS } from "@/lib/constants";
import { usePaytmJSCheckout } from "@/lib/hooks/usepaytmjscheckout";

import AdvanceEmiModal from "./advance-emi";
import FileSelectModal from "../../loan-details/file-select-modal";
import { Link } from "@/i18n/routing";
import { sendEventAnalytics } from "@/lib/hooks/eventAnalytics";

const LoanCard = ({
  appId,
  loanAmount,
  loanLabel,
  emiAmount,
  nextEmiDate,
  advanceEmi,
  overDueCount = 0,
  paidEmiCount = 0,
  overDueAmount = 0,
  totalEmiCount = 0,
}) => {
  const [openAdvanceEMIModal, setOpenAdvanceEMIModal] = useState(false);
  const [openFileSelectModal, setOpenFileSelectModal] = useState(false);
  const url = `${process.env.NEXT_PUBLIC_PAYTM_HOST}/merchantpgpui/checkoutjs/merchants/${process.env.NEXT_PUBLIC_PAYTM_RETAIL_MID}.js`;
  const [generatePaymentToken, { data: paymentDetails }] =
    useInitiatePaymentMutation();
  const { data: customerData } = useGetCustomerQuery();
  const [scriptLoaded, handleScript] = usePaytmJSCheckout(url, paymentDetails);
  const InitiatePayment = () => {
    let body = {
      source: "DIGI2WEB",
      txnAmount: overDueAmount
        ? overDueAmount?.toString()
        : emiAmount?.toString(),
      custId: appId,
      isRetail: "true",
      transactionTowards: "OTHER",
    };
    if (
      !paymentDetails?.token ||
      paymentDetails?.loanAmount !== loanAmount?.toString()
    ) {
      generatePaymentToken(body);
    } else {
      handleScript({ type: "load" }, body?.txnAmount);
    }
  };

  useEffect(() => {
    if (paymentDetails?.token) {
      sendEventAnalytics({
        eventName: WEB_EVENTS.PAYTM_REDIRECTION_TRANSACTION_TOKEN,
        appId: appId,
        ...customerData?.data,
      });
      handleScript({ type: "load" }, paymentDetails?.loanAmount);
    }
  }, [paymentDetails?.token]);
  return (
    <PaperComponent
      sx={{
        p: 2,
        height: "100%",
        borderRadius: 5,
        maxWidth: { xs: 300 },
        minWidth: { xs: 300, sm: 400, md: 600 },
      }}
    >
      <PaperComponent
        elevation={1}
        sx={{
          p: 2,
          border: overDueAmount > 0 ? "1px solid rgba(237, 28, 36, 0.2)" : "",
          backgroundColor:
            overDueAmount > 0
              ? "rgba(237, 28, 36, 0.2)"
              : "rgba(229, 241, 241, 0.5)",
          borderRadius: 3,
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0,
        }}
      >
        <Stack
          gap={2}
          flexGrow={1}
          direction={{ xs: "column", sm: "row" }}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Stack>
            <Typography variant="h5" gutterBottom color={"#3F3F3F"}>
              {loanLabel}
            </Typography>
            <Typography
              variant="h4"
              fontWeight={"bold"}
              color={WEB_COLORS.primary}
              gutterBottom
            >
              {CurrencyConverter(loanAmount)}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              for {totalEmiCount} Months
            </Typography>
          </Stack>
          <Stack flexGrow={1} px={2} alignItems={"center"} gap={2}>
            <MultiSegmentProgressBar
              overdue={overDueCount}
              paid={paidEmiCount}
              tenure={totalEmiCount}
            />
            {appId && (
              <Link
                style={{ alignItems: "center", display: "flex" }}
                href={`/loan-details/${appId}`}
              >
                View Loan Details <ChevronRight />
              </Link>
            )}
            {/* <MatrixBorderProgressBar
              paid={paidEmiCount}
              overdue={overDueCount}
              total={totalEmiCount}
              paidColor="limegreen"
              overdueColor="orangered"
              remainingColor="lightgrey"
            /> */}
          </Stack>
        </Stack>
      </PaperComponent>

      <PaperComponent
        elevation={2}
        sx={{
          p: 2,
          backgroundColor: "rgba(229, 241, 241, 0.2)",
          borderRadius: 3,
          borderTopLeftRadius: 0,
          borderTopRightRadius: 0,
        }}
      >
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
          spacing={2}
          mt={2}
        >
          <Stack>
            <Typography
              variant="h6"
              fontWeight={"bold"}
              color={WEB_COLORS.primary}
            >
              {CurrencyConverter(emiAmount)}
              <Typography variant="body2" color="textSecondary">
                Next EMI Amount{" "}
              </Typography>
            </Typography>
          </Stack>
          <DividerComponent
            orientation="vertical"
            variant="middle"
            sx={{ height: "3em", ml: 1 }}
          />
          <Stack>
            <Typography
              variant="h6"
              fontWeight={"bold"}
              color={WEB_COLORS.primary}
            >
              {nextEmiDate}
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Next EMI Date
            </Typography>
          </Stack>
        </Stack>
        <Stack mt={2}>
          <ButtonComponent
            disabled={!scriptLoaded}
            onClick={InitiatePayment}
            buttonStyle={{
              backgroundColor:
                overDueAmount > 0 ? "rgba(237, 28, 36, 1)" : WEB_COLORS.primary,
            }}
            variant="submit"
          >
            {overDueAmount > 0
              ? `Pay ${CurrencyConverter(overDueAmount)} Now`
              : `Pay ${CurrencyConverter(emiAmount)} Now`}
          </ButtonComponent>
        </Stack>
      </PaperComponent>

      <Grid container spacing={2} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={12} md={6}>
          <ButtonComponent
            variant="text"
            color="primary"
            fullWidth
            endIcon={<ChevronRight />}
            onClick={() => setOpenFileSelectModal(true)}
          >
            Download Documents
          </ButtonComponent>
        </Grid>
        <Grid item xs={12} sm={12} md={6}>
          <ButtonComponent
            onClick={() => setOpenAdvanceEMIModal(true)}
            variant="text"
            color="primary"
            fullWidth
            endIcon={<ChevronRight />}
          >
            Advance EMI
          </ButtonComponent>
        </Grid>
      </Grid>
      <AdvanceEmiModal
        appId={appId}
        emiAmount={emiAmount}
        advanceEmi={advanceEmi}
        open={openAdvanceEMIModal}
        handleModal={setOpenAdvanceEMIModal}
      />
      <FileSelectModal
        appId={appId}
        open={openFileSelectModal}
        handleModal={setOpenFileSelectModal}
      />

      {/* <ButtonComponent
        onClick={() => {
        }}
        variant="text"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        endIcon={<ChevronRight />}
      >
        Repayment Summary
      </ButtonComponent> */}
    </PaperComponent>
  );
};

export default LoanCard;
